define("shared/components/shared/asset-upload", ["exports", "@ember/component", "@ember/object", "@ember/service", "@glimmer/component", "@glimmer/tracking", "@ember/template-factory"], function (_exports, _component, _object, _service, _component2, _tracking, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _canDropUpload, _fileHandler, _trackUploadAttempt, _uploadMediaItem;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/object",0,"@ember/service",0,"@glimmer/component",0,"@glimmer/tracking",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _classPrivateMethodInitSpec(e, a) { _checkPrivateRedeclaration(e, a), a.add(e); }
  function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _classPrivateMethodGet(s, a, r) { return _assertClassBrand(a, s), r; }
  function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <div
    class="cUP--upload"
    {{did-insert this.setupUploaders}}
    {{droppable
      isWindow=true
      onDragEnter=this.dragEnterHandler
      onDragLeave=this.dragLeaveHandler
      onDrop=this.dropHandler
    }}
  >
    <div class="cUP--upload__icon" id="dropbox-chooser" {{on "click" this.openDropbox}}>
      {{svg-jar "dropbox" class="o--icon--lg"}}
    </div>
    <div class="cUP--upload__text">
      <span>
        {{t "media_items.new.from_dropbox"}}
      </span>
    </div>
    <div class="cUP--upload__text is--base" {{on "click" this.browse}}>
      <span>
        {{html-safe (t "media_items.new.from_upload")}}
      </span>
    </div>
  </div>
  <input accept="image/*,video/*,video/mp4,video/x-m4v" class="u--hide" id="input" multiple type="file" />
  
  {{#if this.isDragging}}
    <Shared::Modal class="cDZ--modalBg">
      <div class="o--modalDialog cDZ--modal">
        <div class="cDZ--dropzone">
          <span class="cDZ--dropzone__text u--text--white u--text--lg">
            {{t "media_items.new.drag_drop"}}
          </span>
        </div>
      </div>
    </Shared::Modal>
  {{/if}}
  */
  {
    "id": "HNdzVuGA",
    "block": "[[[11,0],[24,0,\"cUP--upload\"],[4,[38,0],[[30,0,[\"setupUploaders\"]]],null],[4,[38,1],null,[[\"isWindow\",\"onDragEnter\",\"onDragLeave\",\"onDrop\"],[true,[30,0,[\"dragEnterHandler\"]],[30,0,[\"dragLeaveHandler\"]],[30,0,[\"dropHandler\"]]]]],[12],[1,\"\\n  \"],[11,0],[24,0,\"cUP--upload__icon\"],[24,1,\"dropbox-chooser\"],[4,[38,2],[\"click\",[30,0,[\"openDropbox\"]]],null],[12],[1,\"\\n    \"],[1,[28,[35,3],[\"dropbox\"],[[\"class\"],[\"o--icon--lg\"]]]],[1,\"\\n  \"],[13],[1,\"\\n  \"],[10,0],[14,0,\"cUP--upload__text\"],[12],[1,\"\\n    \"],[10,1],[12],[1,\"\\n      \"],[1,[28,[35,4],[\"media_items.new.from_dropbox\"],null]],[1,\"\\n    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n  \"],[11,0],[24,0,\"cUP--upload__text is--base\"],[4,[38,2],[\"click\",[30,0,[\"browse\"]]],null],[12],[1,\"\\n    \"],[10,1],[12],[1,\"\\n      \"],[1,[28,[35,5],[[28,[37,4],[\"media_items.new.from_upload\"],null]],null]],[1,\"\\n    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n\"],[13],[1,\"\\n\"],[10,\"input\"],[14,\"accept\",\"image/*,video/*,video/mp4,video/x-m4v\"],[14,0,\"u--hide\"],[14,1,\"input\"],[14,\"multiple\",\"\"],[14,4,\"file\"],[12],[13],[1,\"\\n\\n\"],[41,[30,0,[\"isDragging\"]],[[[1,\"  \"],[8,[39,7],[[24,0,\"cDZ--modalBg\"]],null,[[\"default\"],[[[[1,\"\\n    \"],[10,0],[14,0,\"o--modalDialog cDZ--modal\"],[12],[1,\"\\n      \"],[10,0],[14,0,\"cDZ--dropzone\"],[12],[1,\"\\n        \"],[10,1],[14,0,\"cDZ--dropzone__text u--text--white u--text--lg\"],[12],[1,\"\\n          \"],[1,[28,[35,4],[\"media_items.new.drag_drop\"],null]],[1,\"\\n        \"],[13],[1,\"\\n      \"],[13],[1,\"\\n    \"],[13],[1,\"\\n  \"]],[]]]]],[1,\"\\n\"]],[]],null]],[],false,[\"did-insert\",\"droppable\",\"on\",\"svg-jar\",\"t\",\"html-safe\",\"if\",\"shared/modal\"]]",
    "moduleName": "shared/components/shared/asset-upload.hbs",
    "isStrictMode": false
  });
  let AssetUploadComponent = _exports.default = (_class = (_canDropUpload = /*#__PURE__*/new WeakSet(), _fileHandler = /*#__PURE__*/new WeakSet(), _trackUploadAttempt = /*#__PURE__*/new WeakSet(), _uploadMediaItem = /*#__PURE__*/new WeakSet(), class AssetUploadComponent extends _component2.default {
    constructor() {
      super(...arguments);
      _classPrivateMethodInitSpec(this, _uploadMediaItem);
      _classPrivateMethodInitSpec(this, _trackUploadAttempt);
      _classPrivateMethodInitSpec(this, _fileHandler);
      _classPrivateMethodInitSpec(this, _canDropUpload);
      _initializerDefineProperty(this, "auth", _descriptor, this);
      _initializerDefineProperty(this, "dropbox", _descriptor2, this);
      _initializerDefineProperty(this, "mediaItemUpload", _descriptor3, this);
      _initializerDefineProperty(this, "segment", _descriptor4, this);
      _initializerDefineProperty(this, "dragCounter", _descriptor5, this);
    }
    get isDragging() {
      return this.dragCounter > 0;
    }
    setupUploaders() {
      const fileInput = document.querySelector('input[type=file]');
      fileInput.addEventListener('change', event => {
        _classPrivateMethodGet(this, _fileHandler, _fileHandler2).call(this, event);
        fileInput.value = ''; // reset 'change'
      });
    }
    browse() {
      _classPrivateMethodGet(this, _trackUploadAttempt, _trackUploadAttempt2).call(this, 'upload');
      document.querySelector('input[type=file]').click();
    }
    openDropbox() {
      _classPrivateMethodGet(this, _trackUploadAttempt, _trackUploadAttempt2).call(this, 'dropbox');
      this.dropbox.openDropbox.perform();
    }
    dropHandler(event) {
      event.preventDefault();
      event.stopPropagation();
      this.dragCounter = 0;
      if (_classPrivateMethodGet(this, _canDropUpload, _canDropUpload2).call(this, event)) {
        _classPrivateMethodGet(this, _fileHandler, _fileHandler2).call(this, event);
      }
    }
    dragEnterHandler(event) {
      if (_classPrivateMethodGet(this, _canDropUpload, _canDropUpload2).call(this, event)) {
        this.dragCounter++;
      }
    }
    dragLeaveHandler() {
      this.dragCounter--;
    }
  }), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "dropbox", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "mediaItemUpload", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "segment", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "dragCounter", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return 0;
    }
  }), _applyDecoratedDescriptor(_class.prototype, "setupUploaders", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "setupUploaders"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "browse", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "browse"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "openDropbox", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "openDropbox"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "dropHandler", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "dropHandler"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "dragEnterHandler", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "dragEnterHandler"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "dragLeaveHandler", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "dragLeaveHandler"), _class.prototype)), _class);
  function _canDropUpload2(event) {
    return event.dataTransfer?.types.includes('Files') && !event.dataTransfer?.types.includes('id') && !this.args.dropDisabled;
  }
  function _fileHandler2(event) {
    const files = event.dataTransfer?.files || event.target?.files;
    for (let i = 0; i < files.length; i++) {
      const file = files.item(i);
      _classPrivateMethodGet(this, _uploadMediaItem, _uploadMediaItem2).call(this, file);
    }
  }
  function _trackUploadAttempt2(buttonType) {
    this.segment.track('attempted-uploading-media', {
      area: this.args.location,
      button: buttonType,
      account_owner: !this.args.isContributor
    });
  }
  function _uploadMediaItem2(file) {
    this.mediaItemUpload.uploadMediaItem(file, this.args.isContributor ? {
      approved: false,
      submittedBy: this.auth.currentUserModel
    } : undefined);
  }
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, AssetUploadComponent);
});